import { ParcoursStubPage } from '../../../components/parcours/ParcoursStubPage';
import { getParcoursStub } from '../../../config/parcours-particuliers';

export default function RenovationGlobalePage() {
  const parcours = getParcoursStub('renovation-globale');
  if (!parcours) return null;
  return <ParcoursStubPage parcours={parcours} />;
}
